import React, { Fragment } from 'react';

interface ISafeTextProps {
  text: string,
}

export const SafeText = ({ text }: ISafeTextProps) => {
  const formattedText = replaceLineBreaksWithBr(text);

  return (
    <>
      {formattedText}
    </>
  );
};

function replaceLineBreaksWithBr(text: string) {
  return text.split('\n').map((line, index) => (
    <Fragment key={index}>
      {line}
      {index < text.split('\n').length - 1 && <br />}
    </Fragment>
  ));
}
